import React from "react"

import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"
import SmallButton from "../../../toolkits/SmallButton/SmallButton"

import {ERROR_CODE, SUCCESS_CODE} from "../../../constants/other"
import {useDeleteCalendarMutation} from "../../../api/publicHolidayCalendars"


const DeleteCalendarPopup = ({calendar, setUserMessage, close, onSubmit}) => {
    const [deleteCalendar, {isLoading}] = useDeleteCalendarMutation()

    const handleSubmit = () => {
        deleteCalendar(calendar.id)
            .unwrap()
            .then(() => {
                close()
                onSubmit()
                setUserMessage({message: "Calendar was successfully deleted!", code: SUCCESS_CODE})
            })
            .catch(error => {
                setUserMessage({message: error.message, code: ERROR_CODE})
            })
    }

    return (
        <CustomPopup text_title={`Do you want to delete the "${calendar.name}" calendar?`} isSubtitle isAgreePopup>
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton disabled={isLoading} btnType="secondary" onClick={close}> CANCEL </SmallButton>
                    <SmallButton loading={isLoading} onClick={handleSubmit}> DELETE </SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DeleteCalendarPopup
